import React from "react";
import Page from "../templates/support/supportpage";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
